import { render, staticRenderFns } from "./SingleFormUI.vue?vue&type=template&id=0ad77acb&scoped=true&"
import script from "./SingleFormUI.vue?vue&type=script&lang=js&"
export * from "./SingleFormUI.vue?vue&type=script&lang=js&"
import style0 from "./SingleFormUI.vue?vue&type=style&index=0&id=0ad77acb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad77acb",
  null
  
)

export default component.exports